import React from 'react';

import NavBar from '../components/NavBar';

function Tenants() {
    return (
        <>
            <div className='h1'>
            <h1>Tenants</h1>
            </div>
            
            <div className='center-paragraph'>
                <p>* If tenant moves out, change the Unit ID to NULL.</p>
            </div>
            <div className='parent'>
                <div className='child'>
                    <label>
                        Add Tenant: 
                    </label>
                    <select name="unit_id" id="dropdown">
                        <option value="unit_id">Unit ID</option>
                        <option value="NULL">NULL (Past Tenant/Move Out)</option>
                        <option value="000001">000001</option>
                        <option value="000002">000002</option>
                        <option value="000003">000003</option>
                    </select>
                    <input type="text" placeholder="First Name*" />
                    <input type="text" placeholder="Last Name*" />
                    <input type="text" placeholder="Email" />
                    <input type="text" placeholder="Phone*" />
                    <input type="submit" value="Submit" />
                    <div className='center-note'>
                        <p>* indicates a required field.</p>
                    </div>
                </div>
                <br></br>
                <div className='child'>
                    <label>
                        Search Tenants: 
                    </label>
                    <input type="text" placeholder="Unit ID" />
                    <input type="text" placeholder="First Name" />
                    <input type="text" placeholder="Last Name" />
                    <input type="text" placeholder="Email" />
                    <input type="text" placeholder="Phone" />
                    <input type="submit" value="Submit" />
                </div>
            </div>

            <table id="customers" className='center-table'>
            <tr>
                    <th>Tenant ID</th>
                    <th>Unit ID</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th></th>
                </tr>
                <tr>
                    <td>000001</td>
                    <td>000001</td>
                    <td>Alice</td>
                    <td>Apple</td>
                    <td>aapple@email.com</td>
                    <td>(999)999-9999</td>
                    <td><button>Edit</button><button>Delete</button></td>
                </tr>
                <tr>
                    <td>000002</td>
                    <td>000001</td>
                    <td>Blake</td>
                    <td>Apple</td>
                    <td>bapple@email.com</td>
                    <td>(999)999-9998</td>
                    <td><button>Edit</button><button>Delete</button></td>
                </tr>
                <tr>
                    <td>000003</td>
                    <td>000002</td>
                    <td>Charles</td>
                    <td>Corn</td>
                    <td>charliecorn@email.com</td>
                    <td>(999)999-9997</td>
                    <td><button>Edit</button><button>Delete</button></td>
                </tr>
                <tr>
                    <td>000004</td>
                    <td>000003</td>
                    <td>David</td>
                    <td>Danes</td>
                    <td>dd@email.com</td>
                    <td>(999)999-9996</td>
                    <td><button>Edit</button><button>Delete</button></td>
                </tr>
            </table>

            <br></br>
            
            <div>
                <NavBar/>
            </div>
        </>
    );
}

export default Tenants;